import { fetchGetUrl,getAbtestConfig } from '@/service/land';
import { getQueryString,getLinkType,getSessionToken } from '@/utils'

const state = {
  loading: false,
  linkType: getLinkType() || '', // 落地页的type
  isDark: false,
  abConfig:{}
}

const getters = {
  getAbConfig(state) {
    return sessionStorage.getItem('abConfig') ? JSON.parse(sessionStorage.getItem('abConfig')) : state.abConfig
  }
}

const mutations = {
  SET_LOAD(state, data) {
    state.loading = data
  },
  SET_TYPE(state, data) {
    sessionStorage.setItem('linkType', data)
    state.linkType = data
  },
  SET_IS_DARK(state, data) {
   state.isDark = data
  },
  SET_AB_CONFIG(state, data) {
    sessionStorage.setItem('abConfig',JSON.stringify(data))
    state.abConfig = data
   },
}

const actions = {
 showLoad({ commit, state }, data) {
  commit('SET_LOAD', data)
},
// 如果链接上拼接news_feed  需要调用接口获取type
async fetchGetUrl({ commit, state }, data) {
  const getType = function (url) {
    if(url) {
      const url_ = url.indexOf('?') > -1 ? url.split('?')[1] : url
        return getQueryString('type', '?' + url_)
      }else {
        return ''
      }
    }
    const res = await fetchGetUrl(data)
    if(res.status == 1) {
      // 如果配置低代码链接则直接跳转
      if(res.response.url.includes('lyntx')){
        // 去掉ad参数防止重复请求下发的链接
        // 清楚url上的type参数 防止多个type
        // 注意如果商户后台配置参数要有type
        window.location.href = `${res.response.url}${window.location.search.replace(/[?&]ad=[^&]*/, '').replace(/[?&]type=[^&]*/, '').replace('?','&')}`
        return;
      }
      let type = getType(res.response.url)
      // XYF90和XYF85的灰度
      if(type.includes('RedirectGray')){
        try{
          const tokenKey = getSessionToken().slice(-4, -2);
          if(tokenKey <= window.__LAND_PAGE_CONFIG__?.XYF90XYF85RedirectGray){
            type = getQueryString('link1') || 'XYF90'
          }else{
            type = getQueryString('link2') || 'XYF85'
          }
        }catch(e){
          type = 'XYF85'
          console.log(e);
        }
      }
      commit('SET_TYPE', type)
    }
    return res
  },
  async checkIsDark({ commit, state }, data) {
    try {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      function darkModeHandler() {
        if (mediaQuery.matches) {
          console.log('现在是深色模式')
          commit('SET_IS_DARK',1)
        } else {
          console.log('现在是浅色模式')
          commit('SET_IS_DARK',0)
        }
      }
        // 判断当前模式
      darkModeHandler()
      // 监听模式变化
      mediaQuery.addListener(darkModeHandler)
    } catch (error) {
      commit('SET_IS_DARK',0)
    }
    
  },
  async getAbtestConfig({ commit, state }, data) {
    // if(sessionStorage.getItem('abConfig')){
    //   return state.abConfig
    // }
   const res = await getAbtestConfig({ //todo mock
     token: getSessionToken()
   })
  //  let res = {
  //   "status": 1,
  //   "message": "success",
  //   "response": {
  //       "download_page_popup_abtest": true,
  //       "optimization_abtest": true,
  //       "download_page_frate_abtest": true,
  //       "download_page_pro_feature_abtest": true,
  //       "download_page_header_abtest": true
  //     },
  //       "time": 1704960501,
  //       "trace_id": "202401111608219874229686"
  //   }
   if(res.status == 1) {
    commit('SET_AB_CONFIG',res.response)
   }
   console.log(res.response);
   return res
  }

}

export default { namespaced: true, state, mutations, actions, getters }
